// Complete Indian education system — classes and subjects

export const CLASS_GROUPS = [
  {
    group: "Pre-School",
    classes: ["Nursery", "LKG", "UKG"]
  },
  {
    group: "Primary (1–5)",
    classes: ["Class 1", "Class 2", "Class 3", "Class 4", "Class 5"]
  },
  {
    group: "Middle (6–8)",
    classes: ["Class 6", "Class 7", "Class 8"]
  },
  {
    group: "High School (9–10)",
    classes: ["Class 9", "Class 10"]
  },
  {
    group: "Senior Secondary (11–12)",
    classes: [
      "Class 11 – Science (PCM)",
      "Class 11 – Science (PCB)",
      "Class 11 – Commerce",
      "Class 11 – Arts",
      "Class 12 – Science (PCM)",
      "Class 12 – Science (PCB)",
      "Class 12 – Commerce",
      "Class 12 – Arts",
    ]
  },
 
  {
    group: "Graduation",
    classes: [
      "B.Tech – CSE"
    ]
  }
 
 
];

// All classes flat list for dropdowns
export const ALL_CLASSES = CLASS_GROUPS.flatMap(g => g.classes);

// Subjects by class level
export const SUBJECTS_BY_CLASS = {
  "Nursery":  [],
  "LKG":      [],
  "UKG":      [],

  "Class 1":  ["English", "Hindi", "Maths", "EVS", "Drawing"],
  "Class 2":  ["English", "Hindi", "Maths", "EVS", "Drawing"],
  "Class 3":  ["English", "Hindi", "Maths", "EVS", "Drawing", "GK"],
  "Class 4":  ["English", "Hindi", "Maths", "EVS", "Science", "Social Science"],
  "Class 5":  ["English", "Hindi", "Maths", "Science", "Social Science"],

  "Class 6":  ["English", "Hindi", "Maths", "Science", "Social Science", "Sanskrit"],
  "Class 7":  ["English", "Hindi", "Maths", "Science", "Social Science", "Sanskrit"],
  "Class 8":  ["English", "Hindi", "Maths", "Science", "Social Science", "Sanskrit"],

  "Class 9":  ["English", "Hindi", "Maths","Physics","Chemistry","Biology", "History" ,"Civics","Geography", "Sanskrit"],
  "Class 10": ["English", "Hindi", "Maths","Biology","Physics","Chemistry",  "History" ,"Civics","Geography", "Sanskrit"],

  "Class 11 – Science (PCM)": ["Physics", "Chemistry", "Maths", "English", "Computer"],
  "Class 11 – Science (PCB)": ["Physics", "Chemistry", "Biology", "English","Computer"],
  "Class 11 – Commerce":      ["Accountancy", "Business Studies", "Economics", "English", "Maths"],
  "Class 11 – Arts":          ["History", "Geography", "Political Science", "Economics", "Hindi", "English"],

  "Class 12 – Science (PCM)": ["Physics", "Chemistry", "Maths", "English", "Computer"],
  "Class 12 – Science (PCB)": ["Physics", "Chemistry", "Biology", "English","Computer"],
  "Class 12 – Commerce":      ["Accountancy", "Business Studies", "Economics", "English", "Maths"],
  "Class 12 – Arts":          ["History", "Geography", "Political Science", "Economics", "Hindi", "English"],

  

  "B.Tech – CSE":         ["Data Structures", "system Design","Algorithms", "DBMS", "OS", "Computer Networks", "Python", "Java", "C++"],
  

  
};

// Get subjects for a class
export const getSubjectsForClass = (className) => {
  return SUBJECTS_BY_CLASS[className] || [];
};

// All unique subjects (for teacher profile — they can teach multiple)
export const ALL_SUBJECTS = [...new Set(Object.values(SUBJECTS_BY_CLASS).flat())].sort();